/**
 * Deterministic stand-in avatars for the dashboard.
 *
 * The dashboard never fetches real profile photos — a roster or a comment thread would cost a
 * request per render for no product requirement — so people are drawn as initials on a hue
 * derived from their id. Same person, same colour, everywhere on the page.
 */

/** First + last initial, falling back to the first two letters of a single-word name. */
export function initialsOf(name) {
  const parts = String(name || "")
    .split(/\s+/)
    .filter(Boolean);
  const first = parts[0]?.[0] || "?";
  const second = parts.length > 1 ? parts[parts.length - 1][0] : parts[0]?.[1] || "";
  return `${first}${second}`.toUpperCase();
}

/** Stable per-user avatar hue for the design's `oklch(0.6 0.07 H / 0.4)` tint. */
export function hueOf(id) {
  let hash = 0;
  const value = String(id || "");
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) % 360;
  }
  return hash;
}

/** The inline style for an initials bubble, so every surface tints identically. */
export function avatarTintStyle(id) {
  return { background: `oklch(0.6 0.07 ${hueOf(id)} / 0.4)` };
}
